import { Component,EventEmitter,Inject,Optional} from '@angular/core';
import { FormBuilder,Validators,ControlContainer,FormGroup  } from '@angular/forms';
import { Router } from '@angular/router';
import { PfmCategoryDetailsFormHelper,PfmCategoryDetailsFormState} from './pfm-category-details-form.helper';
import { BaseFpxFormComponent,ValidatorService } from '@fpx/core';
import { PfmspendsService } from '../pfmspends-service/pfmspends.service';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { IPopupScreenData } from 'src/app/common/models/popup-screen-data.model';
import { CommonService } from 'src/app/common.service';


@Component({
 selector: 'app-pfm-category-details-form',
  templateUrl: './pfm-category-details-form.component.html',
  styleUrls: ['./pfm-category-details-form.component.scss'],
  providers : [ PfmCategoryDetailsFormHelper]
  })

export class PfmCategoryDetailsFormComponent extends BaseFpxFormComponent<PfmCategoryDetailsFormHelper, PfmCategoryDetailsFormState> {

  constructor(
    @Optional() controlContainer: ControlContainer,
    formBuilder: FormBuilder,
    private router: Router,
    public pfmCategoryDetailsFormHelper: PfmCategoryDetailsFormHelper,
    public pfmspendsService: PfmspendsService,
    private validatorService: ValidatorService,
    public commonService:CommonService,

  ) {
    super(formBuilder, router,controlContainer, pfmCategoryDetailsFormHelper);
  }
   protected override doPreInit(): void {
	this.setDataService(this.pfmspendsService);
  }


  protected override doPostInit(): void {

  }
}
